module.exports = __webpack_public_path__ + "e4fce2bf0a4b1cdf4e71f65f4719a71f.svg";